/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

/* ==========================================================================
   Google Analytics 4 (gtag.js) + element-level engagement tracking
   Measurement ID: G-746VFW8063

   WHAT THIS FILE OWNS
   - select_promotion : homepage hero banner clicks + homepage collection links
   - select_item      : product clicks from homepage rows and collection pages
   These are the CLICK signals in the funnel. The Google & YouTube app's pixel
   does not send them, so without this file they do not exist anywhere.

   WHAT THIS FILE DELIBERATELY DOES NOT OWN  (revised Sep 12 2026 audit)
   - page_view      The Google & YouTube app tag owns it. This file now configs
                    with send_page_view:false so the property is never set up
                    twice into a duplicate pageview.
   - view_item_list The app tag already sends a RICHER version: real collection
                    id and title ("Plushies & More", not "plushies-and-more"),
                    shopify_US_<pid>_<vid> item ids, variant_id, sku, price,
                    brand and index. A second, weaker copy used to be emitted
                    here. It double-counted list views on every collection page
                    and therefore deflated the list-view -> click rate this
                    tracking exists to measure. Removed.
   - purchase / begin_checkout / add_to_cart
                    Settings > Customer events (the "GA4 Ecommerce" pixel).
                    purchase moves to Shopify Flow -> Measurement Protocol; see
                    the identity-capture block at the bottom of this file.

   ITEM IDS
   item_id is the real Shopify product id, read from the theme's
   <product-card data-product-id>, and upgraded to the app's exact
   shopify_US_<pid>_<vid> form whenever that item is already present in the
   dataLayer. It used to be the URL handle ("gold-ingot-plush"), which joined to
   nothing in Merchant Center or Google Ads.
   ========================================================================== */
(function () {
  var GA_MEASUREMENT_ID = 'G-746VFW8063';

  // --- Load gtag.js ---------------------------------------------------------
  var s = document.createElement('script');
  s.async = true;
  s.src = 'https://www.googletagmanager.com/gtag/js?id=' + GA_MEASUREMENT_ID;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID, { send_page_view: false });

  function productHandleFrom(href) {
    var m = (href || '').match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }

  // Walk up from a clicked link to the theme's <product-card>, which carries
  // the real Shopify product id.
  function cardFor(el) {
    while (el && el !== document.body) {
      if (el.tagName && el.tagName.toLowerCase() === 'product-card') return el;
      el = el.parentElement;
    }
    return null;
  }

  // Reuse the app tag's own item payload for this product so our ids are
  // identical to theirs. Returns null when the product is not in the dataLayer.
  function enrich(productId) {
    if (!productId) return null;
    var dl = window.dataLayer || [];
    for (var i = dl.length - 1; i >= 0; i--) {
      var a = dl[i];
      if (!a || a[0] !== 'event' || !a[2] || !a[2].items) continue;
      var items = a[2].items;
      for (var j = 0; j < items.length; j++) {
        var it = items[j];
        var id = it && (it.id || it.item_id);
        if (id && String(id).indexOf('_' + productId + '_') > -1) {
          return {
            item_id: String(id),
            item_name: it.name || it.item_name,
            price: it.price,
            item_variant: it.variant_id
          };
        }
      }
    }
    return null;
  }

  function titleFrom(card, fallback) {
    if (!card) return fallback;
    var t = card.querySelector('.product-card__title') ||
            card.querySelector('[class*="title"]');
    var txt = t && t.textContent ? t.textContent.trim().replace(/\s+/g, ' ') : '';
    return txt || fallback;
  }

  function itemFor(link, listName) {
    var card = cardFor(link);
    var productId = card ? card.getAttribute('data-product-id') : null;
    var handle = productHandleFrom(link.getAttribute('href'));
    var rich = enrich(productId);
    var item = { item_list_name: listName };

    if (rich) {
      item.item_id = rich.item_id;
      item.item_name = rich.item_name || titleFrom(card, handle);
      if (rich.price !== undefined) item.price = rich.price;
      if (rich.item_variant !== undefined) item.item_variant = String(rich.item_variant);
    } else {
      item.item_id = productId || handle;
      item.item_name = titleFrom(card, handle);
    }
    return item;
  }

  // A single click on a card can pass through two overlapping links (the image
  // and the title). Collapse those into one event.
  var lastFire = { key: '', at: 0 };
  function shouldFire(key) {
    var now = Date.now();
    if (key === lastFire.key && now - lastFire.at < 800) return false;
    lastFire = { key: key, at: now };
    return true;
  }

  // --- Homepage element tracking -------------------------------------------
  function initHomepageTracking() {
    var body = document.body;
    if (!body || body.className.indexOf('template-index') === -1) return;
    var main = document.getElementById('main');
    if (!main || typeof gtag !== 'function') return;

    main.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;
      var href = a.getAttribute('href') || '';

      // Product click from a homepage collection row
      var prodHandle = productHandleFrom(href);
      var prodColl = href.match(/\/collections\/([^\/]+)\/products\//);
      if (prodHandle && prodColl) {
        var listName = 'Home: ' + prodColl[1];
        var item = itemFor(a, listName);
        if (!shouldFire('si|' + item.item_id + '|' + listName)) return;
        gtag('event', 'select_item', {
          item_list_id: 'home_' + prodColl[1],
          item_list_name: listName,
          items: [item]
        });
        return;
      }

      // Collection-level link (no /products/)
      var coll = href.match(/\/collections\/([^\/?#]+)(?:[\/?#]|$)/);
      if (coll) {
        var isHeroBanner = a.classList.contains('home-carousel--image_link') ||
                           !!a.closest('[data-section-type="home-carousel"]');
        var promoId = (isHeroBanner ? 'hero_' : 'home_link_') + coll[1];
        if (!shouldFire('sp|' + promoId)) return;
        gtag('event', 'select_promotion', {
          promotion_id: promoId,
          promotion_name: (isHeroBanner ? 'Hero banner: ' : 'Home link: ') + coll[1],
          creative_slot: isHeroBanner ? 'homepage_hero' : 'homepage_link',
          location_id: 'homepage'
        });
      }
    }, true);
  }

  // --- Collection-page tracking (creators, All Products, etc.) --------------
  // view_item_list is intentionally NOT sent here; the app tag owns it.
  function initCollectionTracking() {
    var body = document.body;
    if (!body || body.className.indexOf('template-collection') === -1) return;
    if (typeof gtag !== 'function') return;

    var m = window.location.pathname.match(/\/collections\/([^\/?#]+)/);
    if (!m) return;
    var handle = m[1];
    var listName = 'Collection: ' + handle;
    var main = document.getElementById('main');
    if (!main) return;

    main.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;
      if (!productHandleFrom(a.getAttribute('href'))) return;
      var item = itemFor(a, listName);
      if (!shouldFire('si|' + item.item_id + '|' + listName)) return;
      gtag('event', 'select_item', {
        item_list_id: 'collection_' + handle,
        item_list_name: listName,
        items: [item]
      });
    }, true);
  }

  function init() {
    initHomepageTracking();
    initCollectionTracking();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ==========================================================================
   GA4 identity capture for server-side purchase (added Sep 12 2026)

   WHY THIS EXISTS
   Purchase is moving off the browser and onto Shopify Flow -> GA4 Measurement
   Protocol, because the web pixel only ever sees ~83% of online-store orders
   (ad blockers, consent refusals, closed tabs) and cannot see Shop-app or draft
   orders at all.

   A server-side hit with no identity lands as a brand-new "(direct)" session,
   which would fix the counts and destroy the channel attribution that makes the
   numbers worth having. So we grab GA4's own identifiers here, while we still
   have a browser, and attach them to the cart. They ride onto the order as
   custom attributes, and Flow reads them back out.

   _ga                 = GA1.1.<a>.<b>            -> client_id  "<a>.<b>"
   _ga_746VFW8063      = GS1.1.<session>.<count>. -> session_id, session_number

   Runs at most once per GA session, deferred to idle so it never competes with
   rendering.
   ========================================================================== */
(function () {
  var GA_STREAM_COOKIE = '_ga_746VFW8063';

  function cookie(name) {
    var m = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return m ? decodeURIComponent(m[2]) : null;
  }

  // The stream cookie has had two shapes. Current GA4 (GS2) packs its fields
  // into $-separated tokens and only has THREE dot-separated parts, which the
  // first version of this function mis-parsed into a null session id:
  //   GS2.1.s1757698000$o12$g1$t1757698100$j60$l0$h0
  //           ^session_id  ^session_number
  // The older shape was plain dots:
  //   GS1.1.<session_id>.<session_number>.<...>
  // Both are handled; anything unrecognised yields nulls and the purchase still
  // lands against the right user, just without session stitching.
  function streamIds(v) {
    var out = { sessionId: null, sessionNumber: null };
    if (!v) return out;
    var parts = v.split('.');
    if (parts.length >= 4 && /^[0-9]+$/.test(parts[2])) {
      out.sessionId = parts[2];
      out.sessionNumber = parts[3];
      return out;
    }
    var toks = parts.slice(2).join('.').split('$');
    for (var i = 0; i < toks.length; i++) {
      var t = toks[i];
      var head = t.charAt(0);
      var rest = t.slice(1);
      if (!/^[0-9]+$/.test(rest)) continue;
      if (head === 's') out.sessionId = rest;
      else if (head === 'o') out.sessionNumber = rest;
    }
    return out;
  }

  function identity() {
    var ga = cookie('_ga');
    var stream = cookie(GA_STREAM_COOKIE);
    if (!ga) return null;

    // GA1.1.1234567890.1694500000 -> "1234567890.1694500000"
    var gaParts = ga.split('.');
    if (gaParts.length < 4) return null;
    var clientId = gaParts.slice(-2).join('.');

    var s = streamIds(stream);
    return { clientId: clientId, sessionId: s.sessionId, sessionNumber: s.sessionNumber };
  }

  function alreadySent(id) {
    try {
      return window.sessionStorage.getItem('ga_ids_sent') === id;
    } catch (e) {
      return false;
    }
  }

  function markSent(id) {
    try { window.sessionStorage.setItem('ga_ids_sent', id); } catch (e) {}
  }

  function send() {
    var ids = identity();
    if (!ids) return;

    var stamp = ids.clientId + '|' + (ids.sessionId || '');
    if (alreadySent(stamp)) return;

    var body = 'attributes[ga_client_id]=' + encodeURIComponent(ids.clientId);
    if (ids.sessionId) {
      body += '&attributes[ga_session_id]=' + encodeURIComponent(ids.sessionId);
    }
    if (ids.sessionNumber) {
      body += '&attributes[ga_session_number]=' + encodeURIComponent(ids.sessionNumber);
    }

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body,
      credentials: 'same-origin',
      keepalive: true
    }).then(function () {
      markSent(stamp);
    }).catch(function () {
      // Never let analytics plumbing surface to a shopper.
    });
  }

  function schedule() {
    // gtag writes the _ga cookies on first hit, so give it a beat.
    var run = function () { setTimeout(send, 1200); };
    if (window.requestIdleCallback) {
      window.requestIdleCallback(run, { timeout: 4000 });
    } else {
      run();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
})();
